import context, { IAppUserContext } from '@truckdown/components-systems';
import { IInitializer, IUserContext } from "@truckdown/systems";

import conversations from "./Conversations/Conversations.vue";

class ConversationsInitializer implements IInitializer {
    name: string = 'ConversationsInitializer';
    order: number = 0;

    initialize(context: IUserContext): Promise<void> {
        console.log('Running Conversations Component Initializer from App.Systems');

        let app = (context as IAppUserContext).app;
        app.component('conversations', conversations);
        return new Promise((resolve) => { resolve(); });
    }
}

context.registerService({
    name: 'IInitializer',
    activator: async () => {
        return new ConversationsInitializer();
    }
});